import { module } from 'angular';

export const AWS_FUNCTION_MODULE = 'spinnaker.amazon.function';

module(AWS_FUNCTION_MODULE, []);
